module.exports = __webpack_public_path__ + "static/media/paste.16d03caa.svg";